module.exports = new __parcel__URL__("a-bugss-life.3fbea974.jpg").toString();